<template>
    <div class="form-item">
        <label class="label-caption">Mês</label>
        <select :value="opcaoSelecionada" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        ckAddTodos: {type: Boolean, default: false},
        opcaoSelecionada: {type: Number, default: null}
    },

    computed: {
        lsTipos() {
            const tipos = [
                { id: 1, descricao: 'Janeiro' },
                { id: 2, descricao: 'Fevereiro' },
                { id: 3, descricao: 'Março' },
                { id: 4, descricao: 'Abril' },
                { id: 5, descricao: 'Maio' },
                { id: 6, descricao: 'Junho' },
                { id: 7, descricao: 'Julho' },
                { id: 8, descricao: 'Agosto' },
                { id: 9, descricao: 'Setembro' },
                { id: 10, descricao: 'Outubro' },
                { id: 11, descricao: 'Novembro' },
                { id: 12, descricao: 'Dezembro' }
            ];
            if (this.ckAddTodos) {
                tipos.unshift({ id: 0, descricao: 'TODOS' });
            }
            return tipos;
        }
    },

    methods: {
        atualizarOpcao(event) {
            this.$emit('update:opcaoSelecionada', Number(event.target.value));
        }
    }
};
</script>